import { ComputersStatisticModel } from 'mbs-ui-shared@models/computersStatistic';

export interface ComputersStatisticState {
  oneComputerExist: boolean;
  oneComputerExistLoading: boolean;
  oneComputerExistLoaded: boolean;

  statistic: ComputersStatisticModel;
  statisticLoading: boolean;
  statisticLoaded: boolean;
}

export const initialComputersStatisticModel: ComputersStatisticModel = {
  state: {
    active: 0,
    hidden: 0
  },
  healthState: {
    healthy: 0,
    backup: {
      warning: 0,
      problem: 0,
      overdue: 0
    },
    rmm: {
      warning: 0,
      problem: 0
    }
  },
  versionStatus: {
    outdated: 0,
    unsupported: 0,
    installError: 0
  },
  authStatus: {
    pending: 0
  }
};

export const initialComputersStatisticState: ComputersStatisticState = {
  oneComputerExist: false,
  oneComputerExistLoading: false,
  oneComputerExistLoaded: false,

  statistic: initialComputersStatisticModel,
  statisticLoading: false,
  statisticLoaded: false
};
